export const CHANGE_STEP = 'CHANGE_STEP';

export const UPDATE_STEP = 'UPDATE_STEP';

export const DECREASE_TIMER = 'DECREASE_TIMER';

export const COMPLETE_SETUP_REQUEST = 'COMPLETE_SETUP_REQUEST';

export const COMPLETE_SETUP_SUCCESS = 'COMPLETE_SETUP_SUCCESS';

export const COMPLETE_SETUP_FAILURE = 'COMPLETE_SETUP_FAILURE';

export const GET_SETUP_STATE_REQUEST = 'GET_SETUP_STATE_REQUEST';

export const GET_SETUP_STATE_SUCCESS = 'GET_SETUP_STATE_SUCCESS';

export const GET_SETUP_STATE_FAILURE = 'GET_SETUP_STATE_FAILURE';

export const RESEND_VERIFICATION_CODE_REQUEST = 'RESEND_VERIFICATION_CODE_REQUEST';

export const RESEND_VERIFICATION_CODE_SUCCESS = 'RESEND_VERIFICATION_CODE_SUCCESS';

export const RESEND_VERIFICATION_CODE_FAILURE = 'RESEND_VERIFICATION_CODE_FAILURE';

export const ACTIVATE_DENWA_NANO_REQUEST = 'ACTIVATE_DENWA_NANO_REQUEST';

export const ACTIVATE_DENWA_NANO_SUCCESS = 'ACTIVATE_DENWA_NANO_SUCCESS';

export const ACTIVATE_DENWA_NANO_FAILURE = 'ACTIVATE_DENWA_NANO_FAILURE';

export const SET_LICENCE_STATUS = 'SET_LICENCE_STATUS';
